/**
 * Rococo Surcharge Handler
 * Gestisce la logica per determinare l'ID della variante di sovrapprezzo
 * in base al litraggio selezionato e al bucket del colore.
 */

(function() {
  'use strict';

  // Mappatura ID varianti sovrapprezzo
  // Formato: { BUCKET: { LITRAGGIO: VARIANT_ID } }
  const SURCHARGE_MAP = {
    'A': {
      '1 LT': '56107579769218',
      '4 LT': '56107579801986',
      '12 LT': '56107579834754'
    },
    'B': {
      '1 LT': '56107579867522',
      '4 LT': '56107579900290',
      '12 LT': '56107579933058'
    },
    'C': {
      '1 LT': '56107579965826',
      '4 LT': '56107579998594',
      '12 LT': '56107580031362'
    },
    'D': {
      '1 LT': '56107580064130',
      '4 LT': '56107580096898',
      '12 LT': '56107580129666'
    }
  };

  class RococoSurchargeHandler {
    constructor() {
      this.surchargeMap = SURCHARGE_MAP;
    }

    /**
     * Trova l'ID della variante di sovrapprezzo
     * @param {string} bucket - Il bucket del colore (A, B, C, D)
     * @param {string} variantTitle - Il titolo della variante del prodotto principale (es. "4 LT")
     * @returns {string|null} - L'ID della variante o null se non trovato
     */
    getSurchargeVariantId(bucket, variantTitle) {
      if (!bucket || !variantTitle) return null;

      const cleanBucket = bucket.toUpperCase().trim();
      
      // Normalizza il titolo della variante per trovare il litraggio
      let sizeKey = null;
      if (/\b1\s*LT\b/i.test(variantTitle)) {
        sizeKey = '1 LT';
      } else if (/\b4\s*LT\b/i.test(variantTitle)) {
        sizeKey = '4 LT';
      } else if (/\b12\s*LT\b/i.test(variantTitle)) {
        sizeKey = '12 LT';
      }

      if (sizeKey && this.surchargeMap[cleanBucket] && this.surchargeMap[cleanBucket][sizeKey]) {
        return this.surchargeMap[cleanBucket][sizeKey];
      }

      console.warn(`[Rococo] Nessun sovrapprezzo trovato per Bucket: ${cleanBucket}, Size: ${sizeKey}`);
      return null;
    }
  }

  // Esporta l'handler globalmente
  window.RococoSurchargeHandler = new RococoSurchargeHandler();

})();
